export default function payloadToModel(payload, Model, nextData = {}) {
  const model = new Model({
    ...payload.data,
    ...nextData
  });
  model.cid = payload.cid;
  return model;
}
